import { Tooltip, TableCell } from "@mui/material";
import { Category, TableCellProps, IncidentInfo } from "../types";
import {
  typeTooltipMessages,
  areaTooltipMessages,
  detectionTimeTooltipMessages,
} from "./TooltipMessages";
import { globalStyles } from "../../../../../../styles/globalStyleTheming";

const tooltipTextStyle = {
  color: globalStyles.palette.brand.plain,
  fontSize: "15px",
};

const getTooltipMap = (category: Category) => {
  switch (category) {
    case "type":
      return typeTooltipMessages;

    case "area":
      return areaTooltipMessages;

    case "time":
      return detectionTimeTooltipMessages;
  }
};
function TableCellWithHover({
  name,
  tooltip,
  align,
  incidentInfo,
}: TableCellProps) {
  const messageMap = getTooltipMap(incidentInfo?.category as Category);

  const defaultTitle = <h1 style={tooltipTextStyle}>{tooltip}</h1>;
  const infoTitle = incidentInfo ? (
    <h1 style={tooltipTextStyle}>
      {messageMap[(incidentInfo as IncidentInfo).type]}
    </h1>
  ) : (
    ""
  );

  const fontWeight = incidentInfo ? 300 : 900;
  return (
    <Tooltip placement="top" title={incidentInfo ? infoTitle : defaultTitle}>
      <TableCell sx={{ fontWeight }} align={align}>
        {name}
      </TableCell>
    </Tooltip>
  );
}
export default TableCellWithHover;
